import { ReactNode } from 'react';
import getAmoutValue from 'ui/structure/AmountValue/AmountValue';
import { ITransactionField } from 'ui/structure/TransactionCard';
import { objectMap } from 'utils/helpers';
import { ghsFormatter, formatTwoDigitDate, amountFormatter } from 'utils/formatters';

export const transactionDataConfig = {
  transactionId: 'Transfer ID:',
  bulkId: 'Bulk ID:',
  scheduleId: 'Schedule ID:',
  transferType: 'Transfer Type:',
  sourceAccount: 'Source Account:',
  destinationAccountName: 'Beneficiary Name:',
  destinationAccountNo: 'Destination Account:',
  destinationBank: 'Beneficiary Bank:',
  bankBranch: 'Bank Branch:',
  transactionNarration: 'Narration:',
  workFlowStatus: 'Transaction Status:',
  transactionCharge: 'Transaction Charge:',
  createDate: 'Transaction Date:',
  totalAmount: 'Total Amount:',
  transactionAmount: 'Amount:',
  charge: 'Transaction Charge:',
  SourceAccountType: 'Source Account Name:',
};

export const transactionValuesMapper = (value: string | number, key: string) => {
  switch (key) {
    case 'amount':
    case 'totalAmount':
    case 'charge':
      return getAmoutValue(String(value));
    case 'createDate':
      return formatTwoDigitDate(value);
    case 'transactionAmount':
      return amountFormatter('ghs', false)(String(value));
    case 'transactionCharge':
      return ghsFormatter.format(Number(value));
    default:
      return value;
  }
};

export const getTransactionsArray = (
  data: Record<string, string | number>,
  config: Record<string, string> = transactionDataConfig,
  mapper: (value: string | number, key: string) => ReactNode = transactionValuesMapper,
  sortArray?: string[],
  currency = 'GHS',
): ITransactionField[] => {
  const mappedData = objectMap<ReactNode, string | number>(data, mapper, config);
  const transactionsArray: ITransactionField[] = [];
  const loopWithKeys = sortArray || Object.keys(mappedData);

  loopWithKeys.forEach((key) => {
    const value = mappedData[key];
    if (typeof value === 'undefined') return;

    if (key === 'Total Amount:' || key === 'Transaction Amount:') {
      transactionsArray.push({
        label: key,
        value: getAmoutValue(data[key], currency),
      });
    } else {
      transactionsArray.push({ label: key, value });
    }
  });

  return transactionsArray;
};
